const SET_SCOPES = (state, scopes) => {
  state.scopes = scopes
}

export default {
  SET_SCOPES
}
